module.exports = __webpack_public_path__ + "static/media/fachada.f8758bfd.png";